// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"MX1_TheComp__0kBgV"};